
export const parseSongInfo = (filename: string) => {
  const parts = filename.split(' - ');
  
  if (parts.length === 2) {
    return {
      artist: parts[0],
      title: parts[1]
    };
  }
  
  return {
    artist: 'Unknown Artist',
    title: filename
  };
};
